module.exports = __webpack_public_path__ + "static/media/sumavigroup ui-08.89f31538.png";